export enum MODEL_SPEC_NAMES {
  MODEL_SPEC_INDEX = "model-spec-index",
  MODEL_SPEC_NEW = "model-spec-new",
}
